/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PreviewChannelsViewModel } from "../types/PreviewChannelsViewModel.ts";
import { channelItemViewModelSchema } from "./channelItemViewModelSchema.ts";

export const previewChannelsViewModelSchema = z.object({
  classroomDisciplineId: z.optional(
    z.number().int().describe("ID do planejamento de aula."),
  ),
  disciplineName: z
    .string()
    .describe(
      "Nome da disciplina no idioma padrão, com fallback para o primeiro idioma cadastrado, o nome antigo e o código.",
    )
    .nullish(),
  channels: z
    .array(z.lazy(() => channelItemViewModelSchema))
    .describe("Canais do planejamento de aula.")
    .nullish(),
}) as unknown as ToZod<PreviewChannelsViewModel>;
